import { render, staticRenderFns } from "./ModalConfirmRecoverUser.vue?vue&type=template&id=7015cb68"
import script from "./ModalConfirmRecoverUser.vue?vue&type=script&lang=js"
export * from "./ModalConfirmRecoverUser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports